import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig, DateAdapter, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { Field, Facility } from '@app/_models/facilities';
import { User } from '@app/_models/user';
import { AuthenticationService } from '@app/services/authentication.service';
import { SessionService } from '@app/services/session.service';
import { ReservaModalComponent } from '@app/components/reserva-modal/reserva-modal.component';
import { ReservaRecurrenteModalComponent } from '@app/components/reserva-recurrente-modal/reserva-recurrente-modal.component'
import { Reserva } from '@app/_models/reserva';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { ReservasService } from '@app/services/reservas.service';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-mod-reservas',
  templateUrl: './mod-reservas.component.html',
  styleUrls: ['./mod-reservas.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
  ]
})

export class ModReservasComponent implements OnInit {
  @ViewChild('scrollTarget', { static: true }) scrollTarget: ElementRef;
  canchas: Field[];
  currentDay: Date;
  currentDateSelector = new FormControl(moment());
  currentUser: User;
  access_type: string;
  public day_array = [];
  private refresh: Boolean = false;
  private facility: Facility;
  btnReservaDisabled: Boolean;

  constructor( 
    private authService: AuthenticationService,
    private session: SessionService,
    public modalReserva: MatDialog,
    private reservasService: ReservasService
   ) { }

  ngOnInit() {
    this.currentUser = this.authService.currentUserValue;
    this.canchas = this.session.canchas;
    this.facility = this.session.currentFacility;
    this.setHours();
    this.currentDay = this.reservasService.getSharedCourrencyDay();
    this.access_type = this.session.accessType('reservas');
    this.btnReservaDisabled =  this.access_type != '2';
    this.reservasService.recargarModReservas$.subscribe(() => {
      this.ngOnInit();      
    });
  }

  ngAfterViewInit() {
    const elementToScrollTo = this.scrollTarget.nativeElement.querySelector("[id='14:30']");
    if (elementToScrollTo) {
      elementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  ngDoCheck() {
    if (this.refresh) {
      this.refresh = false;
    }
  }

  setHours() {
    for(var i = 8; i < 28; i++) {
      let h = i;
      if (i >= 24) {
        h = i - 24;
      }
      var hour = ("0" + h).slice(-2);
      var time1 = hour + ":00";
      var time2 = hour + ":30";

      this.day_array.push(time1);
      this.day_array.push(time2);
    }
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Moment>) {
    this.currentDay = event.value.toDate();
    this.reservasService.setSharedCourrencyDay(event.value.toDate());
    this.refresh = true;
    var today = new Date();
    today.setHours(0,0,0,0);
    this.btnReservaDisabled = (this.currentDay < today) || (this.access_type != '2')
  }

  prevDay() {
    var new_date = new Date(this.currentDay.setDate( this.currentDay.getDate() - 1 ));
    this.currentDay = new_date;
    this.currentDateSelector.setValue(moment(new_date));
    var today = new Date();
    today.setHours(0,0,0,0);
    this.btnReservaDisabled = (this.currentDay < today || (this.access_type != '2'))
    this.reservasService.setSharedCourrencyDay(this.currentDay);
  }

  nextDay() {
    var new_date = new Date(this.currentDay.setDate( this.currentDay.getDate() + 1 ));
    this.currentDay = new_date;
    this.currentDateSelector.setValue(moment(new_date));
    var today = new Date();
    today.setHours(0,0,0,0);
    this.btnReservaDisabled = (this.currentDay < today) || (this.access_type != '2')
    this.reservasService.setSharedCourrencyDay(this.currentDay);
  }

  newReserva() {
    const config = new MatDialogConfig();
    config.data = {
      reserva: new Reserva(),
      day: this.currentDay
    }
    config.width = '600px';
    const modal = this.modalReserva.open(ReservaModalComponent, config);

    modal.afterClosed().subscribe((data: any) => {
      if (data) {
        this.currentDay = data;
        this.Refresh()
      }
    })

  }

  reservaRecurrente() {
    const config = new MatDialogConfig();
    config.data = {
      reserva: new Reserva(),
      day: this.currentDay
    }
    config.width = '600px';
    const modal = this.modalReserva.open(ReservaRecurrenteModalComponent, config);

    modal.afterClosed().subscribe((data: any) => {
      if (data) {
        this.currentDay = data;
        this.Refresh()
      }
    })

  }

  public Refresh() {
    var sec = this.currentDay.getSeconds();
    this.currentDay.setMinutes(sec + 1);
  }

}
